window.addEventListener("load", function(event) {

  downloadDocumentationsListeners()
  buttonValidateUserProfileListener()
  buttonValidateUserContactListener()

  displayDocumentation()
  $('[data-role="bloc-navigation-verticale"] aside ul li').click(function() {

    const blockid=$(this).attr('data-plugin-id')

    var dataorder = $(this).attr('data-valeur');
    $("[data-blockid='"+blockid+"'] aside ul li").removeClass('active');
    $(this).addClass('active');


    $("[data-blockid='"+blockid+"'] article").hide()
    $("[data-blockid='"+blockid+"'] [data-order='"+dataorder+"']").fadeIn(500, "swing")


    //$("[data-plugin-id='"+blockid+"'] .detail").fadeIn(500, "swing");
  });
})

const downloadDocumentationsListeners=()=>{

  const $links=document.querySelectorAll("[data-role='download-documentation']")

  for(let $aLink of $links){
    $aLink.addEventListener('click',(e)=>{
      $.ajax({
        url: '/downloadpdf/',
        method: 'POST',
        data: {
          fid:e.target.getAttribute('data-fid'),
          product_nid:e.target.getAttribute('data-product-nid')
        },

        success: function(data) {

        },
        error: function(data) {
          console.log('error')
        }
      })
    })
  }
}

const getUsersInfos=()=>{

  $.ajax({
    url: '/user/1?_format=json',
    method: 'GET',
    success: function(data) {
      console.log(data)
    },
    error: function(data) {
      console.log('error')
    }
  })
}

const buttonValidateUserProfileListener=()=>{
  if(!document.querySelector('[data-role="user-validate-profile"]')){
    return
  }
  document.querySelector('[data-role="user-validate-profile"]').addEventListener('click',(e)=>{

    $values=fetchAllUserProfileFields()

    $.ajax({
      url: '/mon-compte-update',
      method: 'POST',
      data: {
        datas: JSON.stringify($values)
      },
      success: function(data) {
        window.location.href=window.location.href;
      },
      error: function(data) {
        console.log('error')
      }
    })

  })
}

const fetchAllUserProfileFields=()=>{
  $fieldList=[
    'edit-name',
    'edit-field-prenom',
    'edit-field-adresse',
    'edit-field-mail',
    'edit-field-telephone',
    'edit-field-code-postal',
    'edit-field-ville',
    'edit-field-nom-du-service',
    'edit-field-specialites-metiers',
    'edit-field-profession',
    'edit-field-commentaire',

  ]

  let $resultat=new Array()

  for(let $field of $fieldList){
    $temp=new Array()

    $temp.push(document.getElementById($field).getAttribute('name'))
    $temp.push(document.getElementById($field).value)

    $resultat.push($temp)
  }
  return $resultat
}

const buttonValidateUserContactListener=()=>{
  if(! document.querySelector('[data-role="user-validate-contact"]')){
    return
  }
  document.querySelector('[data-role="user-validate-contact"]').addEventListener('click',(e)=>{

    $values=fetchAllUserContactFields()

    $.ajax({
      url: '/mon-compte-contact-update',
      method: 'POST',
      data: {
        datas: JSON.stringify($values)
      },
      success: function(data) {
        window.location.href=window.location.href;
      },
      error: function(data) {
        console.log('error')
      }
    })

  })
}


const fetchAllUserContactFields=()=>{
  $fieldList=[
    'edit-field-attache-commercial-nom',
    'edit-field-attache-commercial-telepho',
    'edit-field-attache-commercial-mail',
    'edit-field-service-administratif-nom',
    'edit-field-service-administratif-tele',
    'edit-field-service-administratif-mail',

  ]

  let $resultat=new Array()

  for(let $field of $fieldList){
    $temp=new Array()

    $temp.push(document.getElementById($field).getAttribute('name'))
    $temp.push(document.getElementById($field).value)

    $resultat.push($temp)
  }
  return $resultat
}

const displayDocumentation=()=>{

  $('.down-pdf').removeClass('hidden')
  console.log($.cookie('est_pro'))
  if($.cookie('est_pro') != "true"){

    $('.down-pdf').addClass('hidden')
  }
}
